import { all, call, put, takeEvery } from 'redux-saga/effects'
import { getBillingList, billingSetState as setState } from '../actions'
import BillingActions from './actions'

export function* GET_BILLING_LIST({ payload }) {
  yield put(setState({ loading: true, billingList }))

  const billingList = yield call(getBillingList, payload)
  yield put(setState({ loading: false, billingList }))
}

export default function* rootSaga() {
  yield all([takeEvery(BillingActions.GET_BILLING_LIST, GET_BILLING_LIST)])
}
